<template>
  <section id="contact" class="contact">
    <div class="container">
      <div class="section-title"></div>
    </div>

    <div>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3251.716724944992!2d51.81663771525144!3d35.41227148025786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzXCsDI0JzQ0LjIiTiA1McKwNDknMDcuOCJF!5e0!3m2!1sen!2snl!4v1685624299689!5m2!1sen!2snl"
        width="1980"
        height="400"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>

    <div class="container">
      <div class="row mt-5">
        <div class="col-lg-6">
          <div class="row">
            <div class="col-md-12">
              <div class="info-box">
                <i class="bx bx-map"></i>
                <h3>آدرس</h3>
                <p>تهران کیلومتر ۴۰ جاده خاوران</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="info-box mt-4">
                <i class="bx bx-envelope"></i>
                <h3>ایمیل</h3>
                <p>info@sabalanmixer.ir</p>
                <br />
                <br />
              </div>
            </div>
            <div class="col-md-6">
              <div class="info-box mt-4">
                <i class="bx bx-phone-call"></i>
                <h3>تماس با ما</h3>
                <p>09122982182 - 09124965748</p>
                <br />
                <p>02136470748</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <form
            action="forms/contact.php"
            method="post"
            role="form"
            class="php-email-form"
          >
            <div class="row">
              <div class="col form-group">
                <input
                  type="text"
                  name="name"
                  class="form-control"
                  id="name"
                  placeholder="نام"
                  required
                />
              </div>
              <div class="col form-group">
                <input
                  type="email"
                  class="form-control"
                  name="email"
                  id="email"
                  placeholder="آدرس ایمیل"
                  required
                />
              </div>
            </div>
            <div class="form-group mt-3">
              <input
                type="text"
                class="form-control"
                name="subject"
                id="subject"
                placeholder="موضوع"
                required
              />
            </div>
            <div class="form-group mt-3">
              <textarea
                class="form-control"
                name="message"
                rows="5"
                placeholder="پیغام"
                required
              ></textarea>
            </div>
            <div class="my-3">
              <div class="loading">Loading</div>
              <div class="error-message"></div>
              <div class="sent-message">پیغام با موفقیت ارسال شد</div>
            </div>
            <div class="text-center">
              <button type="submit">ارسال پیغام</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
</style>